import React from "react";

const Hero = () => {
  const goToViolation = (id) => {
    const violation = document.getElementById(id);
    window.scrollTo({
      top: violation.offsetTop - 120,
      behavior: "smooth",
    });
  };

  return (
    <section id="home">
      <div className="container-fluid position-relative vh-100 p-0">
        <div className="hero-container">
          <h2 className="hero-h2">
            Kamera Digital 16MP Ramah Lingkungan yang Seperti Kamera Film
          </h2>
          <div className="d-flex flex-column">
            <h1 className="hero-h1">Berani Berkreasi</h1>
            <h1 className="hero-h1-2">Berani Tampil Beda</h1>
          </div>

          <div style={{ height: "3.5rem" }}></div>
          <button
            className="btn btn-black btn-send hero-btn"
            style={{ width: "200px" }}
            onClick={() => goToViolation("best-seller")}
          >
            BELI SEKARANG
          </button>
        </div>
      </div>
    </section>
  );
};

export default Hero;
